import { help, know } from '../../../data';

export const navigationItems = [
  {
    title: 'Ayuda',
    subtitle: 'Descubre con qué temas te puede ayudar un asesor.',
    othertitle: 'Descubre con qué otros temas te puede ayudar un asesor:',
    path: '/asesores/ayuda',
    sublinks: help
  },
  {
    title: 'Qué saber',
    subtitle: 'Todo lo que tienes que saber sobre el asesoramiento.',
    othertitle: 'Descubre qué más tienes que saber sobre el asesoramiento:',
    path: '/asesores/saber',
    sublinks: know
  },
];
